import React from "react";
import {connect} from "react-redux";
import {
  Datagrid,
  TextField,
  ReferenceField,
  BooleanField,
  SingleFieldList,
  ChipField
} from "admin-on-rest";
import List from '../../../components/CRM/List';
import Avatar from "material-ui/Avatar";
import {listStyle} from "./style";
import ActionBar from "../../../components/CRM/ActionBar/";
import StoreFilter from "./StoreFilter";
import ActionMenu from "../../../components/CRM/ActionMenu";
import {refreshView as refreshViewAction} from "admin-on-rest";
import RelationsManyField from "../../../components/RelationsManyField";

const FullNameField = ({record = {}, avatar = ''}) => (
  <div style={listStyle.textFieldContainer}>
    <Avatar src={avatar} />
    <span style={listStyle.textFieldStyle}>
      {record.first_name} {record.last_name}
    </span>
  </div>
);

class StoreDataListBase extends React.Component {
  state = {
    selectedRow: [],
    selectedAll: "",
    selectedIds: [],
    promosFilter: {},
    deleted: false
  };

  componentDidMount() {
    const now = new Date().toISOString();
    this.setState({
      promosFilter: {
        active: true,
        valid_from_lt: now,
        valid_to_gte: now
      },
      deleted: true
    });
  }

  componentDidUpdate(nextProps) {
    if (this.props.record.list.ids !== nextProps.record.list.ids) {
      if (this.props.location.pathname === "/kiosks/") {
        this.setState({deleted: true});
      }
    }
  }

  componentWillUnmount() {
    this.setState({deleted: false});
  }

  handleRowSelection = value => {
    if (Array.isArray(value)) {
      this.props.record.selectedRow = value;
    } else {
      this.props.record.selectedAll = value;
    }
    this.handleIdsSelection();
  };

  handleIdsSelection = () => {
    if (this.props.record.selectedAll === "none") {
      this.handleUnselectAll();
    } else {
      if (this.props.record.selectedAll === "all") {
        this.handleSelectAll();
      } else {
        if (
          this.props.record.selectedRow[0] ||
          this.props.record.selectedRow[0] === 0
        ) {
          this.handleSelectIds();
        } else {
          this.handleUnselectIds();
        }
      }
    }
  };

  handleUnselectAll = () => {
    this.props.record.ids = [];
    this.props.record.selectedAll = "";
    this.props.record.selectedRow = "";
    this.handleResetState();
    this.props.refreshView();
  };

  handleSelectAll = () => {
    this.props.record.ids = this.props.record.list.ids;
    this.props.record.selectedRow = [];
    this.props.record.selectedAll = "";
    this.handleResetState();
  };

  handleSelectIds = () => {
    this.props.record.list.ids.forEach((pair, index) => {
      this.props.record.selectedRow.forEach((value, key) => {
        if (value === index) {
          this.handleAddId(pair);
        }
        this.state.selectedIds.forEach((id, nb) => {
          if (id === pair) {
            if (!this.props.record.selectedRow.includes(index)) {
              this.handleRemoveId(id);
            }
          }
        });
      });
    });
  };

  handleAddId = pair => {
    if (this.state.selectedIds && !this.state.selectedIds.includes(pair)) {
      this.state.selectedIds.push(pair);
      this.props.record.ids = this.state.selectedIds;
    }
  };

  handleRemoveId = id => {
    function remove(array, element) {
      const index = array.indexOf(element);

      if (index !== -1) {
        array.splice(index, 1);
      }
    }
    remove(this.state.selectedIds, id);
    this.props.record.ids = this.state.selectedIds;
  };

  handleUnselectIds = () => {
    this.props.record.ids = [];
    this.props.record.selectedRow = [];
    this.handleResetState();
    this.props.refreshView();
  };

  handleResetState = () => {
    this.setState({
      selectedIds: [],
      selectedAll: "",
      selectedRow: []
    });
  };

  render() {
    const props = {...this.props};
    const {promosFilter} = this.state;

    return (
      <List
        title="resources.stores.name"
        {...props}
        actions={<ActionBar {...props} />}
        sort={{field: "name", order: "ASC"}}
        filters={<StoreFilter />}
      >
        <Datagrid
          options={{
            multiSelectable: true,
            selectable: true,
            onRowSelection: this.handleRowSelection
          }}
          headerOptions={{
            adjustForCheckbox: true,
            displaySelectAll: true,
            enableSelectAll: true
          }}
          bodyOptions={{
            displayRowCheckbox: true,
            deselectOnClickaway: false,
            showRowHover: true
          }}
          rowOptions={{
            selectable: true
          }}
        >
          <TextField label="resources.stores.fields.storeName" source="name" />
          <TextField
            source="sms_sender"
            label="resources.stores.fields.sender"
          />

          <ReferenceField
            label="resources.stores.fields.storeOwner"
            source="partner_id"
            reference="partners"
          >
            <FullNameField source="first_name" avatar={props.avatar} />
          </ReferenceField>

          {this.props.configuration.promos &&
            this.props.configuration.promos.enabled === true && (
              <RelationsManyField
                filter={promosFilter}
                label="resources.stores.fields.activePromos"
                target="kiosk_id"
                source="promos_id"
                reference="promos"
                deleted={this.state.deleted}
              >
                <SingleFieldList>
                  <ChipField source="name" />
                </SingleFieldList>
              </RelationsManyField>
            )}

          <TextField label="resources.stores.fields.email" source="email" />

          <TextField label="resources.stores.fields.phone" source="phone" />

          <ReferenceField label="resources.stores.fields.region" source="region_id" reference="regions">
            <TextField source="name" />
          </ReferenceField>

          <TextField
            label="resources.stores.fields.deviceSerialNumber"
            source="device_serial_number"
          />
          <BooleanField
            elStyle={listStyle.booleanFieldStyle}
            label="resources.stores.fields.active"
            source="active"
          />

          <ActionMenu />
        </Datagrid>
      </List>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    record: state.admin.resources[props.resource],
    configuration: state.configuration,
    avatar: state.images.avatar_logo
  };
};

const StoreDataList = connect(
  mapStateToProps,
  {
    refreshView: refreshViewAction
  }
)(StoreDataListBase);

export default StoreDataList;



// WEBPACK FOOTER //
// ./src/containers/CRM/Stores/StoreDataList.js